import { render, staticRenderFns } from "./ExcelOwnership.vue?vue&type=template&id=f5e175f8&scoped=true&"
import script from "./ExcelOwnership.vue?vue&type=script&lang=js&"
export * from "./ExcelOwnership.vue?vue&type=script&lang=js&"
import style0 from "./ExcelOwnership.vue?vue&type=style&index=0&id=f5e175f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e175f8",
  null
  
)

export default component.exports